<div class="card d-flex gap-1 mb-0">
    @if (showSectionToggle) {
        <div class="d-flex">
            <div class="btn-group section-selector ms-auto"
                 role="group">
                @for (section of sections; track section) {
                    <button class="btn btn-primary"
                            [ngClass]="{ active: !section.visible }"
                            (click)="toggleSection(section)"
                            [adaptTooltip]="section.tooltip ?? section.name">
                        <dx-check-box (onContentReady)="onCheckBoxReady($event, section)"
                                      [text]="section.code"
                                      [value]="isSectionConfigured(section)"
                                      [readOnly]="true"></dx-check-box>
                    </button>
                }
            </div>
        </div>
    }

    <div class="card-body px-1">
        <adapt-time-scheduler #scheduler
                              [items]="items"
                              [periods]="periods"
                              [sections]="sections"
                              [showSections]="true"
                              [start]="start"
                              [cycle]="cycle"
                              (initialised)="queuedScheduler.setCallee($event); initialised.emit($event)"
                              (itemMouseEnter)="onItemHover($event)"
                              (itemMouseLeave)="onItemHover($event, true)"
                              [selectedItem]="selectedItem"
                              (selectedItemChange)="selectedItemChange.emit($event)"></adapt-time-scheduler>

        @if (popupItem) {
            <dx-popover [target]="popupItem.element"
                        [visible]="popupVisible">
                <div *dxTemplate="let data = model of 'content'">
                    @if (popupItem?.item; as item) {
                        @if (item.metadata?.name; as name) {
                            <div>{{ name }}</div>
                        }
                        <div>
                            <i class="fal fa-fw fa-calendar"></i>
                            {{ item.start | adaptDate }}
                        </div>
                        <div>
                            <i class="fal fa-fw fa-timer"></i>
                            {{ formatTime(item) }}
                        </div>
                        @if (item.metadata?.location; as location) {
                            <div>
                                <i class="fal fa-fw fa-location-dot"></i>
                                {{ location }}
                            </div>
                        }
                        @if (item.metadata?.extensions?.isEnded) {
                            <div>
                                <small>This meeting has been completed.</small>
                            </div>
                        }
                    }
                </div>
            </dx-popover>
        }
    </div>

    <div class="d-flex">
        <div class="btn-group period-selector ms-auto"
             role="group">
            <button class="btn btn-primary btn-start-time"
                    (click)="scheduler.gotoOriginalDate()"
                    adaptTooltip="Go to current time">
                <i class="fal fa-fw fa-grid-2"></i>
            </button>
            @for (period of scheduler.periods; track period) {
                <button class="btn btn-primary"
                        [class]="period.classes"
                        [ngClass]="{ active: scheduler.currentPeriod === period }"
                        (click)="scheduler.changePeriod(period)"
                        [adaptTooltip]="period.tooltip ? period.tooltip : ''">
                    {{ period.name }}
                </button>
            }
        </div>
    </div>
</div>
